import { css } from '@emotion/react';

import { flex } from 'src/styles/utils';

import { colors } from '../../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';

export const title = css`
  label: title;
  ${ZeeFontBold(24)}
  text-align: left;
  color: ${colors.AccentDarkGrayColor};
  ${MQ.MediaMdMaxWidth} {
    width: 100%;
    text-align: center;
    ${ZeeFontBold(16)}
  }
`;

export const popUpContainer = css`
  ${MQ.MediaMaxWidth480} {
    padding: 0px;
  }
  width: 100%;
  padding: 30px;
`;
export const popUpBlock = css`
  title: popupBlock;
  padding-right: 2px;
  padding-top: 20px;
  max-width: 300px;
  margin: 0 auto;
  ${MQ.MediaMaxWidth480} {
    width: 100%;
    text-align: center;
  }
`;

export const otpInputContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
`;

export const otpInputField = css`
  width: 50px;
  height: 45px;
  border-radius: 6px;
  border: 1px solid ${colors.greyText};
  text-align: center;
  ${ZeeFontBold(20)}
  background-color: ${colors.Transparent};

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  [type='number'] {
    -moz-appearance: textfield;
  }
  &:focus {
    outline: none;
    border-color: ${colors.Purple};
  }
`;

export const verifyButton = (validOtp: boolean) => css`
  label: button;
  background: ${colors.PurpleBtn};
  ${ZeeFontRegular(14)}
  border: 1px solid ${colors.PurpleBtn};
  border-radius: 6px;
  box-sizing: border-box;
  color: ${colors.white};
  cursor: pointer;
  display: inline-block;
  padding: 15px 20px;
  text-align: center;
  width: 100%;
  margin-top: 30px;
  opacity: ${validOtp ? 1.0 : 0.5};
`;

export const dottedBottomBorder = css`
  border-bottom: 1.5px dotted ${colors.AccentDarkGrayColor};
  color: ${colors.AccentDarkGrayColor};
  ${ZeeFontRegular(14)}
  font-weight: 500;
`;
export const resendOtpSeconds = css`
  color: ${colors.AccentDarkGrayColor};
  ${ZeeFontRegular(12)}
  font-weight: 400;
`;

export const editDetailsWrapper = css`
  ${MQ.MediaMdMaxWidth} {
    text-align: center;
  }
`;

export const resendOtpWrapper = css`
  margin-top: 44px;
  text-align: center;
  ${ZeeFontRegular(14)}
`;
export const resendOtpButton = css`
  cursor: pointer;
  ${ZeeFontRegular(14)}
  color: ${colors.PurpleLight};
`;
export const resendOtpTimer = css`
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;

export const mobileInfo = css`
  margin-top: 10px;
  ${ZeeFontRegular(14, 25)}
  ${MQ.MediaMdMaxWidth} {
    text-align: center;
  }
`;

export const error = css`
  color: ${colors.ErrorColor};
`;

export const message = css`
  margin-top: 20px;
  ${ZeeFontRegular(12)}
`;

export const editIcon = css`
  margin-left: 4px;
`;
export const editIconWrapper = css`
  cursor: pointer;
  margin-left: 5px;
`;

// User onboard css
export const userOnboardPopUpContainer = css`
  ${popUpContainer}
  padding:0;
  padding-top: 12px;
`;

export const userOnboardPopUpBlock = css`
  title: popupBlock;
  ${MQ.MediaMaxWidth480} {
    width: 100%;
    text-align: center;
  }
`;

export const userOnboardTitle = css`
  ${title};
  ${ZeeFontBold(18)}
`;

export const userOnboardOtpInputContainer = css`
  ${otpInputContainer};
  margin-top: 17px;
`;

export const userOnboardMobileInfo = css`
  ${mobileInfo};
  margin-top: 8px;
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;

export const userOnboardMobileDottedBorder = css`
  ${dottedBottomBorder}
  border-bottom: 0.5px dashed ${colors.PrimaryGreyColorAlpha0};
  ${ZeeFontRegular(14)}
`;

export const userOnboardOtpInputField = css`
  ${otpInputField};
  width: 52px;
  height: 52px;
`;

export const userOnboardVerifyButton = (validOtp: boolean) => css`
  ${verifyButton(validOtp)}
  padding: 12px 20px;
  margin-top: 24px;
`;

export const userOnboardResendOtpWrapper = css`
  ${resendOtpWrapper};
  margin-top: 32px;
`;
export const userOnboardResendOtpSeconds = css`
  ${resendOtpSeconds};
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
`;
export const reCaptchaContainer = css`
  ${flex('row', 'flex-start', 'start')};
  gap: 20px;
  margin-bottom: 20px;
`;
export const captchaErrorMessage = css`
  gap: 20px;
  margin-bottom: 20px;
`;
